/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export const timestamp = () => globalThis.performance.now();
//# sourceMappingURL=timestamp.js.map